import { useQuery } from "@tanstack/react-query"

import { useQueries } from "@/hooks/useRootContext.ts"

import type { BatchInfo, ProjectKey } from "@/lib/client/generated/TypeDefinitions.ts"


export function useBranches(batchInfo: BatchInfo, projectKey: ProjectKey, repo: string, inputValue: string) {
  const client = useQueries().apiClient
  return useQuery({
    queryKey: ["getBranches", projectKey, repo, inputValue, batchInfo.offset],
    queryFn: () => {
      return client.getBranches(batchInfo, projectKey, repo, inputValue)
    },
    placeholderData: (prev) => prev
  })
}